import { render, staticRenderFns } from "./PatientsFormCosmetReg.vue?vue&type=template&id=00febb34&scoped=true&"
import script from "./PatientsFormCosmetReg.vue?vue&type=script&lang=js&"
export * from "./PatientsFormCosmetReg.vue?vue&type=script&lang=js&"
import style0 from "./PatientsFormCosmetReg.vue?vue&type=style&index=0&id=00febb34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00febb34",
  null
  
)

export default component.exports